import { render, staticRenderFns } from "./SwissTrust.vue?vue&type=template&id=3995daa6&scoped=true&"
import script from "./SwissTrust.vue?vue&type=script&lang=js&"
export * from "./SwissTrust.vue?vue&type=script&lang=js&"
import style0 from "./SwissTrust.vue?vue&type=style&index=0&id=3995daa6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3995daa6",
  null
  
)

export default component.exports